import { t } from 'i18next';
import { TableInstance } from 'react-table';
import { PageSizeSelector } from '~components/ui/PageSizeSelector';
import { Pagination } from '~components/ui/Pagination';
import { SubscriptionsTableV2SubscriptionFragment } from './__generated__/SubscriptionsTable.graphql';

export function SubscriptionsTableV2Pagination({
  table,
}: {
  table: TableInstance<SubscriptionsTableV2SubscriptionFragment>;
}) {
  const {
    previousPage,
    canPreviousPage,
    nextPage,
    canNextPage,
    gotoPage,
    state: { pageIndex },
    pageCount,
  } = table;

  return (
    <Pagination
      pageCount={pageCount}
      currentPageIndex={pageIndex}
      hasPreviousPage={canPreviousPage}
      hasNextPage={canNextPage}
      goToPage={gotoPage}
      goToPreviousPage={previousPage}
      goToNextPage={nextPage}
    />
  );
}

export function SubscriptionsTableV2PageSizeSelector({
  table,
  sizes,
}: {
  table: TableInstance<SubscriptionsTableV2SubscriptionFragment>;
  sizes?: number[];
}) {
  const {
    state: { pageSize },
    setPageSize,
  } = table;

  return (
    <PageSizeSelector
      label={t('showRowsPerPage')}
      onChange={setPageSize}
      options={sizes}
      value={pageSize}
    />
  );
}
